import React from 'react';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

import { Button } from "../global/Button";
import { CardLogo } from "../global/CardLogo";
import { SearchForm } from "../global/SearchForm";
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';

import { usePagination, DOTS } from '../global/usePagination';
import { graphql, useStaticQuery } from "gatsby";

export const Ecosystem = (props) => {

  const { t } = useTranslation();
  const { language } = useI18next();

  const { color } = props;
  const fields = props.data;

  let { partners, categories } = useStaticQuery(graphql`
    query {
      partners: allWpPartner(sort: { title: ASC }) {
        edges {
          node {
            language {
              slug
            }
            acf: partnerACF {
              link
            }
            title
            image: featuredImage {
              node {
                localFile {
                  publicURL
                }
              }
            }
            category: partnerCategories {
              nodes {
                id: databaseId
              }
            }
          }
        }
      }
      categories: allWpPartnerCategory(sort: { name: ASC }) {
        edges {
          node {
            language {
              slug
            }
            id: databaseId
            name
          }
        }
      }
    }
  `);

  partners = partners?.edges.filter(edge => edge.node.language.slug === language) || [];
  categories = categories?.edges.filter(edge => edge.node.language.slug === language) || [];

  const specialPartners = ["Money On Chain", "Sovryn", "Tropykus", "BabelFish", "Beefy", "OKU", "Sushi Swap", "Alchemy", "Ripio", "Jumper", "OpenOcean", "Merkl",
    "Gamma", "LI.FI", "Gelato", "Galxe", "Symbiosis", "oooo", "Hyperlane", "Balmy", "Rubic Exchange", "Lemon Cash", "Pagolinea",
    "Andean Wide", "Decrypto",  "SideShift", "iZUMi Finance",  "Steer Finance", "Exodus", "Light Finance", "Wormhole", "Router Protocol", "Buenbit", "LBank", "Rootstock Collective",
    "Mt Pelerin", "Metamask", "Umbrella Network", "MyEtherWallet", "Elk Finance", "NOWnodes", "Envio", "EFY Finance", "RIF", "Efinti", "FastBTC", "PowPeg",
    "Token Bridge", "WayniMovil", "Enkrypt", "MyCrypto", "Ledger", "Trezor", "Edge Wallet", "Wallby", "SafePal", "Third Web", "Tacen",
    "Unitap", "SatoshiSync", "Etherspot", "Vottun", "The Graph", "Rootstock Explorer", "BlockScout", "Footprint Analytics", "Covalent",
     "Outlier Ventures", "Luxor", "Marathon", "Colledge", "UniFi", "Think & Dev", "WakeUp Labs", "Infuy"];
  let specialPartnersList = [];
  let otherPartnersList = [];

  partners.forEach(partner => {
    if (specialPartners.includes(partner.node.title)) {
      specialPartnersList.push(partner);
    } else {
      otherPartnersList.push(partner);
    }
  });

  // Sort other partners alphabetically by title
  otherPartnersList.sort((a, b) => a.node.title.localeCompare(b.node.title));

  // Combine special partners and others, preserving order of special partners
  let sortedPartners = specialPartners.map(name => specialPartnersList.find(partner => partner.node.title === name)).filter(Boolean).concat(otherPartnersList);

  function search(items) {
    return items.filter(
      (item) =>
        (!filter || (item.node?.category?.nodes.length > 0 && item.node.category.nodes.some(cat => cat.id === +filter))) && (item.node.title
          .toString()
          .toLowerCase()
          .indexOf(squery.toLowerCase()) > -1)
    );
  }

  const data = sortedPartners;

  const [squery, setSquery] = useState("");

  function goSearch(event, query) {
    event.preventDefault();
    setPage(1);
    setSquery(query);
  }

  const [filter, setFilter] = useState("");
  const [filterName, setFilterName] = useState(t("See categories"));
  const [items] = useState(data);
  const pageSize = 12;

  const [currentPage, setPage] = useState(1);
  const siblingCount = 0;

  const totalCount = search(items).length;
  const totalPages = Math.ceil(totalCount / pageSize);

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  return (
    <section id='ecosystem' className="pt-lg-16 pb-lg-11 pt-md-11 pb-md-13 pt-9 pb-11">
      <div className="container">
        <div className="row mb-9 mb-md-8 mb-lg-11">
          <div className="col-md-7 col-12 col-lg-6">
            <h2 className="mb-6 mb-lg-3 h3" dangerouslySetInnerHTML={{ __html: fields.title }}>
            </h2>
          </div>
          <div className="col-md-5 col-lg-3 mb-4 mb-md-6 mb-lg-0">
            <div className="mb-4">
              <span className={`zg-label bg-${color ?? 'pink'} me-2`}>{fields.number}</span>
              <span className={`zg-label bg-${color ?? 'pink'}`}>{fields.subtitle}</span>
            </div>
            <p className="subtitle-md mb-0">{fields.text}</p>
          </div>
          <div className="col-lg-3 col-md-5 offset-md-7 offset-lg-0 text-lg-end">
            {fields?.link.url && (
              <Button
                title={fields.link.title}
                url={fields.link.url}
                classes=""
                external={fields.link.target === "_blank"}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6 mb-6 mb-lg-8 d-md-flex align-items-center">
            <DropdownButton
              className="zg-dropdown-btn zg-ecosystem-cat-select"
              id="dropdown-basic-button"
              menuVariant="dark"
              variant="dark"
              title={filterName}
              onSelect={(category) => {
                setFilter(category);
                setPage(1);
              }}
            >
              <Dropdown.Item
                className="zg-dropdown-btn__item"
                eventKey=""
                onClick={() => {
                  setFilterName(t("See categories"));
                }}>
                {t("See categories")}
              </Dropdown.Item>
              {categories.map((item, index) => (
                <Dropdown.Item
                  className="zg-dropdown-btn__item"
                  active={item.node.id === filter}
                  key={index}
                  eventKey={item.node.id}
                  onClick={() => {
                    setFilterName(item.node.name);
                  }}>
                  {item.node.name}
                </Dropdown.Item>
              ))}
            </DropdownButton>

            <SearchForm onSend={goSearch} cssClass="ms-md-4 ms-xl-6 w-100 mt-4 mt-md-0" placeholder={t("Search projects")} />
          </div>
        </div>

        <div className="zg-logos-grid">
          {
            search(items)
              .slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize)
              .map((item, index) => (
                <CardLogo
                  query={squery}
                  key={index}
                  title={item.node.title}
                  image={item.node?.image?.node?.localFile?.publicURL}
                  link={item.node?.acf?.link}
                />
              ))
          }
        </div>
        {(search(items).length === 0 && (
          <div className="h5 mb-0">Sorry, we couldn’t find any results</div>
        ))}
        {totalPages * pageSize > pageSize && (
          <div className="row">
            <div className="col-12 col-xl-6 offset-xl-6">
              <div className="d-flex justify-content-between mt-4 mt-md-7 mt-lg-6">
                <button onClick={(e) => setPage(currentPage - 1)} className="btn-alt btn-page-number"
                  disabled={currentPage === 1}>
                  <span className="px-md-4">
                    <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
                      <path d="M25 12L1 12" stroke="#FAF9F5" strokeWidth="1.5" strokeLinecap="round"
                        strokeLinejoin="round" />
                      <path d="M8 19L1 12L8 5" stroke="#FAF9F5" strokeWidth="1.5" strokeLinecap="round"
                        strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
                <div className="d-flex mx-1 mx-md-2 mx-lg-4">
                  {paginationRange.map((pageNumber, index) => {
                    if (pageNumber === DOTS) {
                      return <span className={`btn-alt btn-page-number mx-1`} key={index}><span>...</span></span>;
                    }

                    return (
                      <button onClick={(e) => setPage(pageNumber)}
                        className={`btn-alt btn-page-number mx-1 ${pageNumber === currentPage ? "active" : ""}`}
                        key={index}><span>{pageNumber}</span></button>
                    );
                  })}
                </div>
                <button onClick={(e) => setPage(currentPage + 1)} className="btn-alt btn-page-number"
                  disabled={currentPage === totalPages}>
                  <span className="px-md-4">
                    <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
                      <path d="M1 12L25 12" stroke="#FAF9F5" strokeWidth="1.5" strokeLinecap="round"
                        strokeLinejoin="round" />
                      <path d="M18 5L25 12L18 19" stroke="#FAF9F5" strokeWidth="1.5" strokeLinecap="round"
                        strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
